<div
  class="ea-progress"
  [ngStyle]="{ width: maxWidth ? maxWidth : '100%' }"
  [ngClass]="{
    'ea-progress-sm': size == 'small',
    'ea-progress-md': size == 'medium',
  }"
>
  <div
    class="progress-bg"
    [ngStyle]="{ background: color }"
    [ngClass]="{ rounded: rounded }"
  ></div>
  <div
    class="progress-bar"
    [ngStyle]="{ width: width + '%', background: color }"
    [ngClass]="{ rounded: rounded }"
  >
    @if (displayText) {
      <span>{{ width }}%</span>
    }
  </div>
</div>
